import { api } from 'src/common/fetch';

export async function getSignupLinkByEmail(
  email: string,
): Promise<{ url: string }> {
  return api.post('/api-admin/signups/', { email });
}
